import LmsDesigns from './designs/LmsDesigns.svelte';
import LmsDashboard from './dashboard/LmsDashboard.svelte';
import LmsCircles from './circles/LmsCircles.svelte';
import LmsCircle from './circles/LmsCircle.svelte';
import Members from './members/Members.svelte';
import MemberProfileDesigns from './designs/MemberProfileDesigns.svelte';
import { LmsUtils } from './utils/LmsUtils';
import LmsDashboardDesigns from './designs/LmsDashboardDesigns.svelte';
import CommunitySettings from './circles/CommunitySettings.svelte';
import GettingStarted from './dashboard/GettingStarted.svelte';

export let LmsApi = {
  GettingStarted: (target) => {
    return new GettingStarted({
      target: target,
      props: {}
    });
  },
  Designs: (target) => {
    return new LmsDesigns({
      target: target,
      props: {}
    });
  },
  MemberProfileDesigns: (target, options) => {
    return new MemberProfileDesigns({
      target: target,
      props: {}
    });
  },
  DashboardDesigns: (target) => {
    return new LmsDashboardDesigns({
      target,
      props: {}
    });
  },
  Dashboard: (target) => {
    return new LmsDashboard({
      target: target,
      props: {}
    });
  },
  Circles: {
    list: async () => {
      return LmsUtils.listCircles();
    },
    getDetails: async (circleUrl) => {
      return LmsUtils.getCircleDetailsByUrl(circleUrl);
    },
    showAll: (target) => {
      return new LmsCircles({
        target: target,
        props: {}
      });
    },
    edit: (target, options) => {
      return new LmsCircle({
        target: target,
        props: options
      });
    },
    settings: (target, options) => {
      return new CommunitySettings({
        target: target,
        props: options
      });
    }
  },
  Members: {
    listAll: (target, options) => {
      return new Members({
        target: target,
        props: options
      });
    }
  }
};


